import { ConfigConstants } from "./config-internal-content";

export const cahootHeader = {
	headerCahootUrls: {
		logo: {
			authOnLink: {
				text: ConfigConstants.MY_ACCOUNT_TRANSSACTION,
				title: 'Cahoot My Account Home',
				url: ConfigConstants.BKS_ACCOUNT_URL,
			},
		},
		links: [
			{
				authOnLink: {
					text: 'Accounts',
					title: ConfigConstants.MY_ACCOUNT_TRANSSACTION,
					url: ConfigConstants.BKS_ACCOUNT_URL,
				},
			},
			{
				authOnLink: {
					text: ConfigConstants.CONTACT_US,
					title: ConfigConstants.CONTACT_US,
					url: '/olb/app/contact-us',
				},
			},
			{
				authOnLink: {
					text: 'Log off',
					title: 'Log off',
					url: '/EBAN_Accounts_ENS/channel.ssobto?dse_operationName=contentTemplate&iurl=%2FLOGSUK_S_ENS%2Fchannel.ssobto%3Fdse_operationName%3DLOGOFF&lang=en-GB&opCode=00000098&layout=transaction',
				},
			},
		],
	}
}